module.exports = __webpack_public_path__ + "img/ydd.2e06ded1.png";